import {
    Box,
    BoxProps,
    Card,
    Container,
    createStyles,
    Grid,
    Image,
    SimpleGrid,
    Stack,
    Text,
    TextProps,
    Title,
    TitleProps
} from "@mantine/core";
import {TitleBadge} from "../../components";
import {Link} from "react-router-dom";
import {useMediaQuery} from "@mantine/hooks";


const useStyles = createStyles((theme) => ({
    feature: {
        padding: theme.spacing.lg,
        backdropFilter: `blur(16px) saturate(180%)`,
        backgroundColor: `rgba(255, 255, 255, 0.75)`,
        border: `none`,

        '&:hover': {
            backgroundColor: theme.colors.secondary[2]
        }
    },
}));

interface IProps {
    boxProps: BoxProps
    titleProps?: TitleProps,
    subtitleProps?: TextProps
}

const WaysToFundSection = ({boxProps, subtitleProps}: IProps) => {
    const {classes, cx, theme} = useStyles();
    const matchesMobile = useMediaQuery('(max-width: 600px)');
    

    return (
        <Box sx={{background: theme.colors.secondary[8], color: theme.white}} {...boxProps}>
            <Container fluid p={36}>
                <Grid>
                    
                  
                    <Grid.Col lg={12}>
                        <Grid>
                            <Grid.Col>
                            <Stack spacing="xs" justify="center" sx={{height: '100%'}}>
                            <TitleBadge title="Make your impact"/>
                            <Title order={3} align={matchesMobile ? 'center' : 'start'}>FundReach Gives You More</Title>
                            <Text align={matchesMobile ? 'center' : 'start'}>Supercharge your fundraising efforts with our unique tools,
                                features and personal
                                support. Helping you raise more money than you could elsewhere!</Text>
                        </Stack>
                                
                            </Grid.Col>

                        </Grid>
                        <SimpleGrid cols={3} breakpoints={[{maxWidth: 'sm', cols: 1}]} >
                            <Card
                                className={cx(classes.feature, 'card')}
                                shadow="md"
                                radius="sm"
                                component={Link}
                                to="/create-campaign"
                            >
                                <Card.Section>
                                    <Image
                                        src="https://images.unsplash.com/photo-1518101645466-7795885ff8f8?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80"/>
                                </Card.Section>
                                <Text mt="md" align="center" {...subtitleProps}>Yourself</Text>
                                <Text><strong>Raise Money for Yourself or Your Business</strong></Text>
                                <Card>
                                <Text>Sometimes, the best way to achieve your goals is by asking for support. Whether you're facing unexpected medical bills, need a boost to start your business, or are chasing a personal dream, Fundreach makes it easy to rally support from family, friends, and even generous strangers. Share your story, inspire others, and watch how small contributions can make a big impact on your life</Text>

                                </Card>
                            </Card>
                          
                            <Card
                                className={cx(classes.feature, 'card')}
                                shadow="md"
                                radius="sm"
                                component={Link}
                                to="/create-campaign"
                            >
                                <Card.Section>
                                    <Image
                                        src="https://images.unsplash.com/photo-1674574124649-778f9afc0e9c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDF8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80"/>
                                </Card.Section>
                                <Text mt="md" align="center" {...subtitleProps}>Friends & Family</Text>
                                <Text><strong>Raise Money for a Friend, Family Member, or an Individual in Need</strong></Text>
                                <Card>
                                <Text>
                            Show your love and support by raising funds for someone who needs help. Whether it’s a family member battling an illness, a friend who has suffered a loss, or someone in your community facing tough times, you can be the beacon of hope they need. Start a campaign, share their story, and help lighten their burden with the power of generosity.


                            </Text>

                                </Card>

                            </Card>
                         
                            <Card
                                className={cx(classes.feature, 'card')}
                                shadow="md"
                                radius="sm"
                                component={Link}
                                to="/create-campaign"
                            >
                                <Card.Section>
                                    <Image
                                        src="https://images.unsplash.com/photo-1593113598332-cd288d649433?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80"/>
                                </Card.Section>
                                <Text mt="md" align="center" {...subtitleProps}>Organization</Text>
                                <Text><strong>Support a Church, Charity, School, or Business</strong></Text>
                                <Card>
                                <Text>
                            Do you want to make a difference through an organization you believe in? Whether it’s a church project, a charity initiative, a non-profit cause, or a school fundraiser, you can start a campaign that mobilizes support. Fundreach helps organizations and businesses raise the funds they need to serve their mission, expand their impact, and create lasting change.
                            </Text>

                                </Card>
                            </Card>
                         


                            <Card
                                className={cx(classes.feature, 'card')}
                                shadow="md"
                                radius="sm"
                                component={Link}
                                to="/create-campaign"
                            >
                                <Card.Section>
                                    <Image
                                        src="https://images.unsplash.com/photo-1593113598332-cd288d649433?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80"/>
                                </Card.Section>
                                <Text mt="md" align="center" {...subtitleProps}>Community</Text>
                                <Text><strong>Fund a Cause That Brings People Together</strong></Text>
                               <Card>
                               <Text>Some causes go beyond individuals and organizations—they belong to the whole community. Whether it’s raising funds for a funeral, a neighborhood improvement project, a local sports event, or a disaster relief effort, Fundreach helps bring people together to support meaningful initiatives. Unite your community, share your vision, and make a collective impact for the greater good.

</Text>
                               </Card>
                            </Card>
                        </SimpleGrid>
                    </Grid.Col>
                </Grid>
            </Container>
        </Box>
    );
};

export default WaysToFundSection;
